import { render, staticRenderFns } from "./footer-documents.vue?vue&type=template&id=8bcba7d6&scoped=true"
import script from "./footer-documents.vue?vue&type=script&lang=js"
export * from "./footer-documents.vue?vue&type=script&lang=js"
import style0 from "./footer-documents.vue?vue&type=style&index=0&id=8bcba7d6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bcba7d6",
  null
  
)

export default component.exports